// Actions

export const TOGGLE = 'Shipping/AddressBook/TOGGLE';

// Action creators

export function toggle() {
  return { type: TOGGLE };
}
